import React from "react";

// Stylized USAPulse star + stripes mark
export function LogoMark({ size = 52 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <clipPath id="starclip">
          <path d="M32 3l6.9 14 15.4 2.2-11.1 10.9 2.6 15.3L32 38.1 18.2 45.4l2.6-15.3L9.7 19.2 25.1 17z" />
        </clipPath>
      </defs>
      {/* stripes block */}
      <g>
        <rect x="30" y="26" width="34" height="4.6" rx="1" fill="#c8102e" />
        <rect x="30" y="33" width="34" height="4.6" rx="1" fill="#0a2a5e" />
        <rect x="30" y="40" width="34" height="4.6" rx="1" fill="#c8102e" />
      </g>
      {/* star */}
      <path d="M32 3l6.9 14 15.4 2.2-11.1 10.9 2.6 15.3L32 38.1 18.2 45.4l2.6-15.3L9.7 19.2 25.1 17z" fill="#0a2a5e" />
      <g clipPath="url(#starclip)">
        <rect x="0" y="0" width="64" height="9" fill="#fff" />
        <rect x="0" y="9" width="64" height="4" fill="#c8102e" />
        <rect x="0" y="20" width="64" height="4" fill="#c8102e" />
        <rect x="0" y="31" width="64" height="4" fill="#c8102e" />
      </g>
      <circle cx="24" cy="18" r="6" fill="#0a2a5e" />
      {[...Array(5)].map((_, i) => {
        const a = (i / 5) * Math.PI * 2 - Math.PI / 2;
        return <circle key={i} cx={24 + Math.cos(a) * 3} cy={18 + Math.sin(a) * 3} r="0.8" fill="#fff" />;
      })}
    </svg>
  );
}

export function Logo({ compact = false }) {
  return (
    <a href="/" className="flex items-center gap-2 sm:gap-3 group" data-testid="site-logo">
      <LogoMark size={compact ? 40 : 54} />
      <div className="leading-none">
        <div className={`font-display font-black tracking-tight text-navy ${compact ? "text-[22px]" : "text-[21px] sm:text-[26px] lg:text-[30px]"}`}>
          USA<span className="text-oldglory-red">PULSE</span><span className="text-oldglory-red">.NET</span>
        </div>
        {!compact && (
          <div className="hidden text-[11px] tracking-wide text-navy/70 mt-1 font-medium sm:block">
            Your Pulse. Your Country. Your Community.
          </div>
        )}
      </div>
    </a>
  );
}
